export const ACTION_ADD = 'add';
export const ACTION_INIT = 'init';
export const ACTION_REMOVE = 'remove';
export const NAME = 'basket';
export const UPDATE = 'update';
export const ACTION_CLEAR = 'clear';
export const ACTION_WRITE_ITEMS = 'write';
export const UPDATE_FOR_LOADING = 'loading'



// WEBPACK FOOTER //
// ./src/services/modulebasket/consts.ts